var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-end",staticStyle:{"z-index":"2","transform":"translateY(50%)"}},[_c('div',{staticClass:"d-flex flex-column align-center justify-space-around"},[_c('v-avatar',{attrs:{"size":"42","color":_vm.stateHintBackgroundColor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }